import React from "react";
import "../styles/intro2.css";
import { Row, Col, Button } from "react-bootstrap";
import Lottie from "lottie-react";
import hourglass from "../assets/illustration.json";
import MyButton from "./MyButton";

const Intro2 = () => {
  return (
    <div className="section" id="intro">
      <Row
        id="intro"
        className="d-sm-flex flex-column-reverse flex-md-row align-items-center container active mb-3 justify-content-evenly"
      >
        <Col className="h-100 col-lg-5">
          <p className="mb-0 fs-3 opacity-50">Hi, I am</p>
          <p className="name">Lutfi Nuril</p>
          <p className="fe">frontend developer</p>
          <p className="describe-me opacity-75">
            Love creating asthetic stuff, especially web apps development. Let's
            make your imagination come true
          </p>
          <div className="d-flex">
            <MyButton
              className="btn"
              href="#contact-me"
              text={`Contact Me`}
              link={`#contact-me`}
            ></MyButton>
            <Button
              target="blank"
              variant="outline-light"
              className="btn"
              href="https://docs.google.com/document/d/1kOiyF0giK-Qp_lODMRSf2HDmA6nnLxYMPrY9xh5lWrY/edit?usp=sharing"
            >
              Download CV
            </Button>
          </div>
        </Col>

        <Col className="col-lg-6">
          <Lottie className="lottie" animationData={hourglass} loop={true} />
        </Col>
      </Row>
    </div>
  );
};

export default Intro2;
